function Counter() {
	return (
		<>
			<div className="row">
				<div style={{ textAlign: "center" }}>Visitor Counter:</div>
			</div>
			<div style={{ display: "flex", justifyContent: "space-around" }}>
				<>
					<img
						src={
							process.env.REACT_APP_HOST === "local"
								? "https://counter4.optistats.ovh/private/freecounterstat.php?c=b986unnrpq631261w62m2knhgq47snp8"
								: "https://counter1.optistats.ovh/private/freecounterstat.php?c=efrtyedw4lbgd27e8757bl6q1xh195tf"
						}
						border="0"
						title="page counter"
						alt="page counter"></img>
				</>
			</div>
		</>
	);
}
export default Counter;
